import type { Habit, UserHabit, HabitActions } from "../types";
type State = {
  availableHabits: UserHabit[];
  installedHabits: UserHabit[];
  allHabits: Record<string, Habit>;
  currentQuery: string | null | undefined;
};

function updateAllHabits(
  allHabits,
  habitLists: (UserHabit[] | null | undefined)[]
) {
  const updated = { ...allHabits };
  habitLists.forEach((list) => {
    if (list) {
      list.forEach((userHabit) => {
        updated[userHabit.habit.habitId] = userHabit.habit;
      });
    }
  });
  return updated;
}

export default function availableHabits(
  state: State = {
    availableHabits: [],
    installedHabits: [],
    allHabits: {},
    currentQuery: null,
  },
  action: HabitActions
): State {
  switch (action.type) {
    case "LOAD_HABIT_SUCCESS":
      return {
        ...state,
        allHabits: { ...state.allHabits, [action.habit.habitId]: action.habit },
      };

    case "LOAD_HABITS_SUCCEEDED":
    case "STORE_HABITS_SUCCEEDED":
      return {
        ...state,
        allHabits: updateAllHabits(state.allHabits, [action.installedHabits]),
        installedHabits: action.installedHabits || state.installedHabits,
      };

    case "LOAD_AVAILABLE_HABITS_SUCCEEDED":
      // make sure that the action matches the current query
      if (action.query === state.currentQuery) {
        return {
          ...state,
          allHabits: updateAllHabits(state.allHabits, [
            action.availableHabits,
            action.installedHabits,
          ]),
          availableHabits: action.availableHabits || state.availableHabits,
          installedHabits: action.installedHabits || state.installedHabits,
        };
      } else {
        return {
          ...state,
          allHabits: updateAllHabits(state.allHabits, [
            action.availableHabits,
            action.installedHabits,
          ]),
        };
      }

    case "LOAD_AVAILABLE_HABITS":
      return { ...state, currentQuery: action.query };
  }

  return state;
}
